import withDirection from 'src/settings/withDirection';
import styled, { createGlobalStyle } from 'styled-components';
import { palette } from 'styled-theme';
import { device } from '@jjj/components';

const GlobalSearchStylesRTL = createGlobalStyle`
  .global-search-modal-overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(51, 51, 51, 0.8);
    z-index: 9999;
  }

  [cmdk-dialog] {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
    z-index: 99999;

    .global-search-modal {
      padding: 0 8px;
      top: 60px;

      @media ${device.tablet} {
        padding: 0;
        top: 20vh;
      }

      position: absolute;
      z-index: 99999999999999999999999;
      max-width: 624px;
      width: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: center;

      [cmdk-root] {
        max-width: 640px;
        width: 100%;
        background: ${palette('grayscale', 5)};
        border-radius: 12px;
        padding: 6px 0 8px 0;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
        border: 1px solid ${palette('border', 1)};
        outline: none;
      }

      [cmdk-input] {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        border: none;
        width: 100%;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: ${props => (props['data-rtl'] === 'rtl' ? '16px' : '56px')};
        padding-right: ${props => (props['data-rtl'] === 'rtl' ? '56px' : '16px')};
        outline: none;
        background: transparent;
        color: ${palette('grayscale', 0)};
        font-weight: 500;
        font-size: 20px;
        line-height: 26px;
        letter-spacing: -0.24px;

        &::placeholder {
          color: ${palette('globalSearch', 4)};
        }
      }

      .search-divider {
        border: 0;
        width: 100%;
        left: 0;
        height: 1px;
        background: ${palette('border', 1)};
        position: relative;
        overflow: visible;
        display: block;
      }

      [cmdk-item] {
        cursor: pointer;
        height: 56px;
        border-radius: 8px;
        font-size: 14px;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 0 8px;
        color: ${palette('grascale', 0)};
        user-select: none;
        transition: background 150ms ease;

        &[data-selected='true'] {
          background: ${palette('globalSearch', 1)};
          color: ${palette('grayscale', 0)};
        }

        &[data-disabled='true'] {
          color: ${palette('globalSearch', 3)};;
          cursor: not-allowed;
        }

        &:active {
          background: ${palette('globalSearch', 3)};
        }

        &:first-child {
          margin-top: 8px;
        }

        & + [cmdk-item] {
          margin-top: 8px;
        }
      }

      [cmdk-list] {
        padding: 0 8px;
        height: 393px;
        overflow: auto;
        overscroll-behavior: contain;
        transition: 100ms ease;
        transition-property: height;
        padding-bottom: 20px;
      }

      [cmdk-group-heading] {
        user-select: none;
        font-size: 12px;
        color: ${palette('grayscale', 7)};
        padding: 0 8px;
        display: flex;
        align-items: center;
      }

      .command-list-empty {
        [cmdk-list-sizer] {
          height: 100%;
        }
      }

      [cmdk-list-sizer] {
        width: 100%;
      }

      [cmdk-empty] {
        display: flex;
        align-items: center;
        height: 100%;
      }
    }
  }
`;

export const LoaderWrapper = styled('div')`
  background: ${palette('grayscale', 5)};
  top: 109px;
  bottom: 36px;
  left: 8px;
  right: 8px;

  @media ${device.tablet} {
    left: 0;
    right: 0;
  }

  position: absolute;
  z-index: 999999999;
  margin-top: -48px;

  .isoContentLoaderCircle {
    stroke: ${palette('globalSearch', 6)} !important;
  }

  .isoContentLoader {
    width: 32px;
    height: 32px;
  }

  .search-label {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0px;
    color: ${palette('grayscale', 0)};

    pointer-events: none;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 48px;
  }
`;

export const LoadMoreWrapper = styled('div')`
  padding: 16px 0;

  .isoContentLoaderCircle {
    stroke: ${palette('globalSearch', 6)} !important;
  }

  .isoContentLoader {
    width: 32px;
    height: 32px;
  }
`;

export const Image = styled('img')`
  border: 1px solid ${palette('border', 1)};
  width: 32px;
  height: 32px;
  max-width: 100%;
  max-height: 100%;
  border-radius: 100%;
  object-fit: cover;
`;

export const GlobalSearchStyles = withDirection(GlobalSearchStylesRTL);
